import React, { useState } from "react";

/* Email validation */
const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

function EmailChipsInput({ value = [], onChange, placeholder, inputRef, onTyping, suggestions = [], contacts = [] }) {
  const [input, setInput] = useState("");
  const [activeIndex, setActiveIndex] = useState(-1);
  const safeValue = Array.isArray(value) ? value : [];

  const addEmail = (email) => {
    const clean = String(email || "").trim().replace(/,$/, "");
    if (!clean) return;
    // If token is not an email, check for a matching contact group and expand
    if (!isValidEmail(clean)) {
      const groupName = String(clean || "").trim().toLowerCase();
      if (groupName) {
        // Find contacts belonging to this group
        const members = (contacts || [])
          .filter(c => String(c.group || "").trim().toLowerCase() === groupName)
          .flatMap(c => Array.isArray(c.emails) ? c.emails : (c.email ? [c.email] : []))
          .map(e => String(e || "").trim())
          .filter(Boolean);

        if (members.length) {
          onChange([...new Set([...safeValue, ...members])]);
          setInput("");
          onTyping?.("");
        }
      }
      return;
    }
    if (safeValue.includes(clean)) return;

    onChange([...safeValue, clean]);
    setInput("");
    setActiveIndex(-1);
    onTyping?.("");
  };

  const addMultipleEmails = (text) => {
    const emails = String(text || "")
      .split(/[\s,;]+/)
      .map(e => e.trim())
      .filter(e => isValidEmail(e));

    if (emails.length) {
      onChange([...new Set([...safeValue, ...emails])]);
      setInput("");
      onTyping?.("");
    }
  };

  const removeEmail = (index) => {
    const next = [...safeValue.slice(0, index), ...safeValue.slice(index + 1)];
    console.log("EmailChipsInput.removeEmail", { before: safeValue, index, after: next });
    onChange(next);
  };

 const handleKeyDown = (e) => {
  if (e.key === "ArrowDown") {
    e.preventDefault();
    if (!suggestions.length) return;
    setActiveIndex((prev) =>
      Math.min(prev + 1, suggestions.length - 1)
    );
    return;
  }

  if (e.key === "ArrowUp") {
    e.preventDefault();
    if (!suggestions.length) return;
    setActiveIndex((prev) =>
      Math.max(prev - 1, 0)
    );
    return;
  }

  if (e.key === "," || e.key === " ") {
    e.preventDefault();
    addEmail(input);
    return;
  }

  if (e.key === "Enter") {
    e.preventDefault();

    if (activeIndex >= 0 && suggestions[activeIndex]) {
      const sel = suggestions[activeIndex];
      addEmail(sel.displayEmail || sel.userId || sel);
      setActiveIndex(-1);
      return;
    }

    addEmail(input);
    return;
  }

  if (e.key === "Backspace" && !input && safeValue.length) {
    removeEmail(safeValue.length - 1);
  }
};

  const handleBlur = () => {
    setTimeout(() => {
      const candidate = String(input || "").trim();
      if (candidate) addEmail(candidate);
    }, 150);
  };

  const handlePaste = (e) => {
    const text = e.clipboardData?.getData("text") || "";
    if (text) {
      e.preventDefault();
      addMultipleEmails(text);
    }
  };
  const visibleSuggestions = Array.isArray(suggestions)
    ? suggestions.filter((item) => {
        const candidate = String(item?.displayEmail || item?.userId || item || "").toLowerCase();
        const typed = String(input || "").toLowerCase().trim();
        return !typed || candidate.includes(typed) || candidate.includes(typed.replace(/[^a-z0-9@._-]/g, ""));
      })
    : [];

  return (
      <div className="email-chips-wrapper">

      {safeValue.map((email, index) => (
        <span key={`${email}-${index}`} className="email-chip">
          <button
            type="button"
            className="email-chip-remove"
            aria-label={`Remove ${email}`}
            onMouseDown={(e) => {
              e.preventDefault();
              removeEmail(index);
            }}
            onClick={(e) => {
              // click fallback for some mobile browsers
              e.preventDefault();
              removeEmail(index);
            }}
          >
            ×
          </button>
          <span className="email-chip-text">{email}</span>
        </span>
      ))}

      <input
        ref={inputRef}
        value={input}
        onChange={(e) => {
          setInput(e.target.value);
          onTyping?.(e.target.value);
        }}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        onPaste={handlePaste}
        placeholder={safeValue.length ? "" : placeholder}
        className="messsendtobox"
      />
      {visibleSuggestions.length > 0 && input.trim() !== "" && (
        <div className="email-suggestions" role="listbox">
          {visibleSuggestions.map((sug, idx) => (
            <div
              key={idx}
              role="option"
              aria-selected={idx === activeIndex}
              className={`email-suggestion ${idx === activeIndex ? "active" : ""}`}
              onMouseDown={(e) => {
                e.preventDefault();
                const email = (sug.displayEmail || sug.userId || sug || "").toString().trim();
                const candidate = email.includes(",") ? email.split(",").pop().trim() : email;
                addEmail(candidate);
                setActiveIndex(-1);
              }}
              onMouseEnter={() => setActiveIndex(idx)}
            >
              <div className="email-suggestion-left">
                <span className="email-suggestion-email">{sug.displayEmail || sug.userId || sug}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


export default EmailChipsInput;
